// ── All category data ──────────────────────────────────────────────────────
// Images: Real photos from reliable sources

export const FRUITS = {
  title:    'Fruit Recognition Game',
  question: 'Which fruit is this?',
  subtitle: 'Select the fruit name that matches the image.',
  accent:   '#E53E3E',
  bgColor:  '#FFF5F5',
 items: [
  { name: 'Apple',      img: 'https://images.pexels.com/photos/102104/pexels-photo-102104.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Peach' }, { name: 'Pear' }, { name: 'Plum' }, { name: 'Apricot' }, { name: 'Lychee' } ] },
  { name: 'Banana',     img: 'https://images.pexels.com/photos/461208/pexels-photo-461208.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Mango' }, { name: 'Papaya' }, { name: 'Plantain' }, { name: 'Pineapple' }, { name: 'Guava' } ] },
  { name: 'Grapes',     img: 'https://images.pexels.com/photos/708777/pexels-photo-708777.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Blueberry' }, { name: 'Cherry' }, { name: 'Blackberry' }, { name: 'Currant' }, { name: 'Plum' } ] },
  { name: 'Watermelon', img: 'https://images.pexels.com/photos/1313267/pexels-photo-1313267.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Melon' }, { name: 'Pumpkin' }, { name: 'Papaya' }, { name: 'Honeydew' }, { name: 'Gourd' } ] },
  { name: 'Orange',     img: 'https://images.pexels.com/photos/327098/pexels-photo-327098.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Lemon' }, { name: 'Grapefruit' }, { name: 'Tangerine' }, { name: 'Lime' }, { name: 'Clementine' } ] },
  { name: 'Strawberry', img: 'https://images.pexels.com/photos/89778/strawberries-frisch-ripe-sweet-89778.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Cherry' }, { name: 'Raspberry' }, { name: 'Lychee' }, { name: 'Cranberry' }, { name: 'Pomegranate' } ] },
  { name: 'Pineapple',  img: 'https://images.pexels.com/photos/947879/pexels-photo-947879.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Coconut' }, { name: 'Papaya' }, { name: 'Durian' }, { name: 'Jackfruit' }, { name: 'Mango' } ] },
  { name: 'Mango',      img: 'https://images.pexels.com/photos/918643/pexels-photo-918643.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Papaya' }, { name: 'Peach' }, { name: 'Banana' }, { name: 'Apricot' }, { name: 'Pineapple' } ] },
  { name: 'Cherry',     img: 'https://upload.wikimedia.org/wikipedia/commons/b/bb/Cherry_Stella444.jpg',
    options: [ { name: 'Grape' }, { name: 'Strawberry' }, { name: 'Plum' }, { name: 'Raspberry' }, { name: 'Cranberry' } ] },
  { name: 'Lemon',      img: 'https://images.pexels.com/photos/952360/pexels-photo-952360.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Orange' }, { name: 'Lime' }, { name: 'Grapefruit' }, { name: 'Tangerine' }, { name: 'Yuzu' } ] },

  { name: 'Peach',      img: 'https://images.pexels.com/photos/1268122/pexels-photo-1268122.jpeg?auto=compress&cs=tinysrgb&w=600',
    options: [ { name: 'Apricot' }, { name: 'Plum' }, { name: 'Nectarine' }, { name: 'Apple' }, { name: 'Mango' } ] },
]
};

export const VEGETABLES = {
  title:    'Vegetable Recognition Game',
  question: 'Which vegetable is this?',
  subtitle: 'Select the vegetable name that matches the image.',
  accent:   '#38A169',
  bgColor:  '#F0FFF4',
  items: [
    { name: 'Carrot',   img: 'https://images.pexels.com/photos/143133/pexels-photo-143133.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [
        { name: 'Potato'   },
        { name: 'Radish'   },
        { name: 'Beetroot' },
        { name: 'Turnip'   },
        { name: 'Parsnip'  },
      ] },
    { name: 'Broccoli', img: 'https://images.pexels.com/photos/1359326/pexels-photo-1359326.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [
        { name: 'Cabbage'     },
        { name: 'Cauliflower' },
        { name: 'Spinach'     },
        { name: 'Lettuce'     },
        { name: 'Kale'        },
      ] },
    { name: 'Tomato',   img:'https://images.pexels.com/photos/533280/pexels-photo-533280.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [
        { name: 'Pepper'  },
        { name: 'Onion'   },
        { name: 'Radish'  },
        { name: 'Beetroot'},
        { name: 'Cherry'  },
      ] },
    { name: 'Potato',   img: 'https://images.pexels.com/photos/7774212/pexels-photo-7774212.jpeg?auto=compress&cs=tinysrgb&w=600' ,
      options: [
        { name: 'Yam'     },
        { name: 'Turnip'  },
        { name: 'Carrot'  },
        { name: 'Radish'  },
        { name: 'Beetroot'},
      ] },
    { name: 'Cucumber', img: 'https://images.pexels.com/photos/2329440/pexels-photo-2329440.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [
        { name: 'Zucchini'   },
        { name: 'Celery'     },
        { name: 'Asparagus'  },
        { name: 'Leek'       },
        { name: 'Courgette'  },
      ] },
    { name: ' Beetroot',  img: 'https://images.pexels.com/photos/244393/pexels-photo-244393.jpeg?auto=compress&cs=tinysrgb&w=600' ,
      options: [
        { name: ' Beetroot'  },
        { name: 'Kale'     },
        { name: 'Cabbage'  },
        { name: 'Arugula'  },
        { name: 'Chard'    },
      ] },
    { name: 'Corn',     img: 'https://images.pexels.com/photos/547263/pexels-photo-547263.jpeg?auto=compress&cs=tinysrgb&w=600' ,
      options: [
        { name: 'Wheat'    },
        { name: 'Barley'   },
        { name: 'Bamboo'   },
        { name: 'Sorghum'  },
        { name: 'Sugarcane'},
      ] },
    { name: 'Pumpkin',  img: 'https://images.pexels.com/photos/5634607/pexels-photo-5634607.jpeg?auto=compress&cs=tinysrgb&w=600' ,
      options: [
        { name: 'Squash'   },
        { name: 'Gourd'    },
        { name: 'Melon'    },
        { name: 'Marrow'   },
        { name: 'Zucchini' },
      ] },
    { name: 'Eggplant', img: 'https://images.pexels.com/photos/321551/pexels-photo-321551.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [
        { name: 'Pepper'   },
        { name: 'Zucchini' },
        { name: 'Cucumber' },
        { name: 'Okra'     },
        { name: 'Radish'   },
      ] },
    { name: 'Onion',    img: 'https://images.pexels.com/photos/6316533/pexels-photo-6316533.jpeg?auto=compress&cs=tinysrgb&w=600' ,  
      options: [
        { name: 'Garlic'   },
        { name: 'Shallot'  },
        { name: 'Leek'     },
        { name: 'Chive'    },
        { name: 'Turnip'   },
      ] },
    { name: 'Garlic',   img: 'https://images.pexels.com/photos/928251/pexels-photo-928251.jpeg?auto=compress&cs=tinysrgb&w=600' ,
      options: [
        { name: 'Onion'   },
        { name: 'Shallot' },
        { name: 'Ginger'  },
        { name: 'Turnip'  },
        { name: 'Radish'  },
      ] },
    { name: 'Mushroom', img: 'https://images.pexels.com/photos/5987623/pexels-photo-5987623.jpeg?auto=compress&cs=tinysrgb&w=600' ,
      options: [
        { name: 'Truffle'    },
        { name: 'Toadstool'  },
        { name: 'Portobello' },
        { name: 'Oyster'     },
        { name: 'Shiitake'   },
      ] },
  ],
};

export const ANIMALS = {
  title:    'Animal Recognition Game',
  question: 'Which animal is this?',
  subtitle: 'Select the animal name that matches the image.',
  accent:   '#805AD5',
  bgColor:  '#FAF5FF',
  items: [
    { name: 'Lion',     img: 'https://images.pexels.com/photos/7082287/pexels-photo-7082287.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Tiger' }, { name: 'Cheetah' }, { name: 'Leopard' }, { name: 'Jaguar' }, { name: 'Puma' } ] },
    { name: 'Elephant', img: 'https://images.pexels.com/photos/3850526/pexels-photo-3850526.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Rhino' }, { name: 'Hippo' }, { name: 'Mammoth' }, { name: 'Tapir' }, { name: 'Walrus' } ] },
    { name: 'Giraffe',  img: 'https://images.pexels.com/photos/34098/south-africa-hluhluwe-giraffes-pattern.jpg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Camel' }, { name: 'Zebra' }, { name: 'Deer' }, { name: 'Moose' }, { name: 'Llama' } ] },
    { name: 'Zebra',    img: 'https://images.pexels.com/photos/1524628/pexels-photo-1524628.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Horse' }, { name: 'Donkey' }, { name: 'Giraffe' }, { name: 'Deer' }, { name: 'Okapi' } ] },
    { name: 'Penguin',  img: 'https://images.pexels.com/photos/641283/pexels-photo-641283.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Puffin' }, { name: 'Seal' }, { name: 'Parrot' }, { name: 'Ostrich' }, { name: 'Duck' } ] },
    { name: 'Tiger',    img: 'https://images.pexels.com/photos/28303046/pexels-photo-28303046.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Lion' }, { name: 'Cheetah' }, { name: 'Leopard' }, { name: 'Jaguar' }, { name: 'Lynx' } ] },
    { name: 'Panda',    img: 'https://images.pexels.com/photos/3608263/pexels-photo-3608263.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Bear' }, { name: 'Koala' }, { name: 'Raccoon' }, { name: 'Badger' }, { name: 'Sloth' } ] },
    { name: 'Dolphin',  img: 'https://images.pexels.com/photos/11342081/pexels-photo-11342081.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Whale' }, { name: 'Shark' }, { name: 'Seal' }, { name: 'Porpoise' }, { name: 'Orca' } ] },
    { name: 'Parrot',   img: 'https://images.pexels.com/photos/40984/animal-ara-macao-beak-bird-40984.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Toucan' }, { name: 'Macaw' }, { name: 'Cockatoo' }, { name: 'Pigeon' }, { name: 'Crow' } ] },
    { name: 'Fox',      img: 'https://images.pexels.com/photos/4934920/pexels-photo-4934920.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Wolf' }, { name: 'Coyote' }, { name: 'Dog' }, { name: 'Jackal' }, { name: 'Raccoon' } ] },
    { name: 'Owl',      img: 'https://images.pexels.com/photos/206676/pexels-photo-206676.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Eagle' }, { name: 'Hawk' }, { name: 'Falcon' }, { name: 'Vulture' }, { name: 'Kestrel' } ] },
    { name: 'Kangaroo', img: 'https://images.pexels.com/photos/3567163/pexels-photo-3567163.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Wallaby' }, { name: 'Koala' }, { name: 'Wombat' }, { name: 'Deer' }, { name: 'Rabbit' } ] },
  ],
};

export const SPORTS = {
  title:    'Sports Recognition Game',
  question: 'Which sport is this?',
  subtitle: 'Select the sport name that matches the image.',
  accent:   '#DD6B20',
  bgColor:  '#FFFAF0',
  items: [
    { name: 'Football',   img: 'https://images.pexels.com/photos/33257254/pexels-photo-33257254.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Rugby' }, { name: 'Basketball' }, { name: 'Volleyball' }, { name: 'Hockey' }, { name: 'Handball' } ] },
    { name: 'Basketball', img: 'https://images.pexels.com/photos/1752757/pexels-photo-1752757.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Volleyball' }, { name: 'Football' }, { name: 'Handball' }, { name: 'Netball' }, { name: 'Water Polo' } ] },
    { name: 'Tennis',     img: 'https://images.pexels.com/photos/5067814/pexels-photo-5067814.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Badminton' }, { name: 'Squash' }, { name: 'Ping Pong' }, { name: 'Racquetball' }, { name: 'Padel' } ] },
    { name: 'Swimming',   img: 'https://images.pexels.com/photos/1263349/pexels-photo-1263349.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Diving' }, { name: 'Water Polo' }, { name: 'Rowing' }, { name: 'Surfing' }, { name: 'Kayaking' } ] },
    { name: 'Cricket',    img: 'https://images.pexels.com/photos/3601184/pexels-photo-3601184.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Baseball' }, { name: 'Softball' }, { name: 'Rounders' }, { name: 'Hockey' }, { name: 'Golf' } ] },
    { name: 'Cycling',    img: 'https://images.pexels.com/photos/248547/pexels-photo-248547.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Skateboarding' }, { name: 'Triathlon' }, { name: 'Motocross' }, { name: 'Rollerblading' }, { name: 'Running' } ] },
    { name: 'Boxing',     img: 'https://images.pexels.com/photos/4761663/pexels-photo-4761663.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Wrestling' }, { name: 'Karate' }, { name: 'Judo' }, { name: 'Taekwondo' }, { name: 'MMA' } ] },
    { name: 'Archery',    img: 'https://images.pexels.com/photos/6620726/pexels-photo-6620726.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Javelin' }, { name: 'Shooting' }, { name: 'Fencing' }, { name: 'Darts' }, { name: 'Slingshot' } ] },
    { name: 'Volleyball', img: 'https://images.pexels.com/photos/1263426/pexels-photo-1263426.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Basketball' }, { name: 'Badminton' }, { name: 'Tennis' }, { name: 'Handball' }, { name: 'Netball' } ] },
    { name: 'Badminton',  img: 'https://images.pexels.com/photos/8007173/pexels-photo-8007173.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Tennis' }, { name: 'Squash' }, { name: 'Ping Pong' }, { name: 'Padel' }, { name: 'Racquetball' } ] },
    { name: 'Golf',       img: 'https://images.pexels.com/photos/1325672/pexels-photo-1325672.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Cricket' }, { name: 'Baseball' }, { name: 'Polo' }, { name: 'Croquet' }, { name: 'Disc Golf' } ] },
    { name: 'Skiing',     img: 'https://images.pexels.com/photos/848618/pexels-photo-848618.jpeg?auto=compress&cs=tinysrgb&w=600',
      options: [ { name: 'Snowboarding' }, { name: 'Ice Skating' }, { name: 'Sledding' }, { name: 'Bobsled' }, { name: 'Snowshoeing' } ] },
  ],
};
